module.exports = __webpack_public_path__ + "static/media/chart-105k-v2.0701b594.svg";